// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__Ctfn6","rotation":"loader_rotation__dcqRN"};